<template>
  <section class="appointment-short-info">
    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.name') }}</label>
      <br>
      <span>{{appointment.name}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.gender') }}</label>
      <br>
      <span>{{$t(`genders.${appointment.gender}`)}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.age') }}</label>
      <br>
      <span>{{`${getAge(appointment.birthdate)} ${$t('date_helpers.years')}`}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.has_medical_prescription') }}</label>
      <br>
      <span>{{appointment.has_medical_prescription ? $t('homelab.labels.yes') : $t('homelab.labels.no')}}</span>
    </div>

    <div class="col-12 mb-5">
      <label class="is-bold mb-0">{{ $t('homelab.labels.address') }}</label>
      <br>
      <span>{{formattedAddressLine1}}</span>
      <br>
      <span>{{formattedAddressLine2}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.entity') }}</label>
      <br>
      <span>{{appointment.entity.name}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.facility') }}</label>
      <br>
      <span>{{appointment.facility ? appointment.facility.name : $t('homelab.unassigned')}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.selected_time') }}</label>
      <br>
      <span>{{getFormatedSelectedTime(appointment.selected_time)}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.scheduled_time') }}</label>
      <br>
      <span>{{getFormatedScheduledTime(appointment.scheduled_time_start, appointment.scheduled_time_end)}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.collect_at_home') }}</label>
      <br>
      <span>{{appointment.collect_at_home ? $t('homelab.labels.yes') : $t('homelab.labels.no')}}</span>
    </div>

    <div class="col-12 col-md-6 mb-3">
      <label class="is-bold mb-0">{{ $t('homelab.labels.status') }}</label>
      <br>
      <span>{{$t(`homelab.statuses.${appointment.status.id}`)}}</span>
    </div>

    <div class="col-12">
      <label class="is-bold mb-0">{{ $t('homelab.labels.appointment_type') }}</label>
      <br>
      <span>{{getFormatedAppointmentType(appointment)}}</span>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    appointment: {
      type: Object,
      required: true
    }
  },
  computed: {
    formattedAddressLine1: function () {
      return [this.appointment.address.line1, this.appointment.address.line2, this.appointment.address.door_number].filter(v => v).join(', ')
    },
    formattedAddressLine2: function () {
      return [this.appointment.address.city, this.appointment.address.postal_code].filter(v => v).join(', ')
    }
  },
  methods: {
    getFormatedSelectedTime: function (date) {
      date = this.moment(this.$options.filters.localTime(date))
      return `${date.format('YYYY-MM-DD')} ${this.$t('date_helpers.hour_to')} ${date.format('HH:mm')}`
    },
    getFormatedScheduledTime: function (start, end) {
      if (start && end) {
        start = this.moment(this.$options.filters.localTime(start))
        end = this.moment(this.$options.filters.localTime(end))
        return `${start.format('YYYY-MM-DD')} ${this.$t('date_helpers.hour_from')} ${start.format('HH:mm')} ${this.$t('date_helpers.hour_to')} ${end.format('HH:mm')}`
      } else {
        return this.$t('homelab.unassigned')
      }
    },
    getFormatedAppointmentType: function (appointment) {
      if (appointment.packages.length > 0) {
        let packages = []
        let charCounter = 0
        let hasMorePackages = false

        for (let i = 0; i < appointment.packages.length; i++) {
          if (charCounter + appointment.packages[i].name.length <= 50) {
            packages.push(appointment.packages[i].name)
          } else {
            hasMorePackages = i < appointment.packages.length
            i = appointment.packages.length
          }
        }

        let formatedAppointmentType = packages.join('; ')

        if (hasMorePackages) {
          formatedAppointmentType = `${formatedAppointmentType} (...)`
        }

        return formatedAppointmentType
      } else if (appointment.insurer) {
        if (appointment.insurer.id === 1) {
          return appointment.insurer.short_name
        } else {
          return `${this.$t('homelab.insurer')} - ${appointment.insurer.short_name}`
        }
      }
    },
    getAge: function (birthdate) {
      return this.moment().diff(this.moment(birthdate), 'year')
    }
  }
}
</script>
